import {
  ArrowLeftIcon,
  PencilIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../components/UI/button";
import { Field, Label } from "../components/UI/fieldset";
import { Heading, Subheading } from "../components/UI/heading";
import { Input } from "../components/UI/input";
import { Select } from "../components/UI/select";

export default function NewEditBeverage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [beverageName, setBeverageName] = useState(
    location.state?.beverageName || ""
  );
  const [color, setColor] = useState("#ff0000");

  return (
    <div className="p-3 bg-gray-50 h-full">
      {/* Header Row */}
      <div className="flex flex-col">
        <div className="flex flex-row gap-2 mb-2">
          <Button plain>
            <ArrowLeftIcon onClick={() => navigate(-1)} />
          </Button>
          <Heading>New/Edit Beverage</Heading>
        </div>
        {/* Brewery Info */}
        <div className="mb-2">
          <Subheading>Brewery: Union Bear</Subheading>
        </div>
      </div>

      <div className="flex gap-20">
        {/* Column 1 - All Inputs */}
        <div className="flex flex-col gap-3">
          {/* Name and Collaborators */}
          <Field className="flex flex-row gap-2">
            <div className="w-1/2">
              <Label required className="whitespace-nowrap">
                Name:
              </Label>
              <Input
                type="text"
                value={beverageName}
                placeholder=""
                onChange={(e) => setBeverageName(e.target.value)}
              />
            </div>
            <div className="w-1/2">
              <Label className="whitespace-nowrap">Collaborators:</Label>
              <Input type="text" placeholder="" />
            </div>
          </Field>

          {/* ABV% and IBU */}
          <Field className="flex flex-row gap-2">
            <div className="w-1/2">
              <Label required className="whitespace-nowrap">
                ABV%:
              </Label>
              <Input type="number" placeholder="" />
            </div>
            <div className="w-1/2">
              <Label className="whitespace-nowrap">IBU:</Label>
              <Input type="number" placeholder="" />
            </div>
          </Field>

          {/* Style Prefix, Style Dropdown, and Style Variation */}
          <Field className="flex flex-row gap-2">
            {/* Style Prefix */}
            <div className="w-1/3">
              <Label className="whitespace-nowrap">Style Prefix:</Label>
              <Input type="text" placeholder="eg, Chocolate Chipotle" />
            </div>

            {/* Style (Dropdown) */}
            <div className="w-1/3">
            <Label required className="whitespace-nowrap">
                Style:
              </Label>
              <div className="flex flex-row gap-1">
                <Select name="style" defaultValue="">
                  <option value="" disabled>
                    Style
                  </option>
                  <option value="ipa">IPA</option>
                  <option value="stout">Stout</option>
                  <option value="lager">Lager</option>
                </Select>
                <div className="flex flex-row">
                  <Button outline>
                    <PlusIcon />
                  </Button>
                  <Button outline>
                    <PencilIcon />
                  </Button>
                </div>
              </div>
            </div>

            {/* Style Variation */}
            <div className="w-1/3">
              <Label className="whitespace-nowrap">Style Variation:</Label>
              <Input type="text" placeholder="eg, With Strawberries" />
            </div>
          </Field>

          {/* Description */}
          <Field>
            <div>
              <Label className="whitespace-nowrap">Description:</Label>
            </div>
            <Input type="text" placeholder="" />
          </Field>
        </div>

        {/* Column 2 - Upload Image */}
        <div className="flex flex-col gap-3 w-fit">
          <div className="flex bg-gray-300 justify-center items-center w-36 h-36">
            <span className="font-bold text-white text-xl">LOGO</span>
          </div>
          <Button outline>Upload Image</Button>
        </div>

        {/* Column 3 - Color Picker */}
        <SketchPicker
          color={color}
          onChange={(updatedColor) => setColor(updatedColor.hex)}
        />
      </div>

      {/* Save/Cancel Buttons */}
      <div className="flex flex-row justify-end gap-3 mt-4 pb-2">
        <Button>Save</Button>
        <Button onClick={() => navigate(-1)}>Cancel</Button>
      </div>
    </div>
  );
}
